import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src879763043/src/codemochi-courses/src/components/routes/public/Lecture.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className="objective">
  <p>
    <span>Objective:</span> Create a function that will block unauthorized
    mutation types from being executed in the GraphCMS server.
  </p>
    </div>
    <p>{`We need to write a function that will search the incoming graphQL query for any of the banned mutation types. These include `}<inlineCode parentName="p">{`deleteMany`}</inlineCode>{`, `}<inlineCode parentName="p">{`updateMany`}</inlineCode>{`, or `}<inlineCode parentName="p">{`publishMany*`}</inlineCode>{`. An easy way to do this, is create a function that searches for a substring using regular expression matching. If it finds a match then it throws an error which immediately stops the proxy request before it can fire off its request to the GraphCMS backend.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-pages/api/graphql.ts"
      }}>{`import * as _ from 'lodash';

export const verifyNotABannedMutation = async (req, res) => {
  const isBannedMutation = req.body.query.match(
    /deleteMany|updateMany|publishMany/g,
  );

  if (!_.isNil(isBannedMutation)) {
    throw new Error('Invalid Mutation Requested');
  }
};

`}</code></pre>
    <p>{`Now we can just call the `}<inlineCode parentName="p">{`verifyNotABannedMutation`}</inlineCode>{` function from the graphql api endpoint:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-pages/api/graphql.ts"
      }}>{`import getConfig from 'next/config';
import { GraphQLClient } from 'graphql-request';
import { verifyNotABannedMutation } from '../../utils/verify';

const { serverRuntimeConfig } = getConfig();

const {
  BRANCH,
  GRAPHCMSURL,
  GRAPHCMSPROJECTID,
  GRAPHCMS_TOKEN,
} = serverRuntimeConfig.graphcms;

const graphqlEndpoint = \`\${GRAPHCMSURL}/\${GRAPHCMSPROJECTID}/\${BRANCH}\`;

export const graphQLClient = new GraphQLClient(graphqlEndpoint, {
  headers: {
    authorization: \`Bearer \${GRAPHCMS_TOKEN}\`,
  },
});

async function proxyGraphql(req, res) {
  try {
    await verifyNotABannedMutation(req, res);
    const { variables, query } = req.body;
    const data = await graphQLClient.rawRequest(query, variables);
    res.json(data);
  } catch (e) {
    res.json({ data: {}, errors: [{ message: e.message }] });
  }
}

export default proxyGraphql;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      